module.exports = __webpack_public_path__ + "static/media/Longmont_REDUCED.d07fd0d7.jpg";